import './spinner.css'

const Spinner = () => {
  return <div className="pokeball-spinner"></div>;
};

export default Spinner;
